export const DuckbillDirectoryBanner = 'https://ik.imagekit.io/duckbill/prod/Task/duckbill-directory-banner-two.png';
export const DuckbillDirectoryBannerWeb = 'https://ik.imagekit.io/duckbill/prod/Task/duckbill-directory-banner-web.png';
